import React from "react";
import { IMaskInput } from 'react-imask';

type ZipCodeInputProps = {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
  }

const ZipCodeInput = React.forwardRef<HTMLInputElement, ZipCodeInputProps>(
    function PhoneNumberInput(props, ref) {
      const { onChange, ...other } = props;
      return (
        <IMaskInput
          {...other}
          mask="00000"
          definitions={{
            '#': /[1-9]/,
          }}
          inputRef={ref}
          onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
          overwrite
        />
      );
    },
  );

  export default ZipCodeInput;